export enum InvoiceDisplayedType {
  Invoice = 'invoice',
  CreditNote = 'creditNote',
  DepositInvoice = 'depositInvoice',
  FinalInvoice = 'finalInvoice',
}
